import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Organization } from '@/types';

export interface OrgWithPermissions extends Organization {
  permissions?: string[];
}

interface OrganizationState {
  organizations: OrgWithPermissions[];
  selectedOrg: OrgWithPermissions | null;
  isLoading: boolean;

  // Actions
  setOrganizations: (orgs: OrgWithPermissions[]) => void;
  setSelectedOrg: (org: OrgWithPermissions | null) => void;
  setLoading: (loading: boolean) => void;
  hasOrgPermission: (permission: string) => boolean;
  reset: () => void;
}

export const useOrganizationStore = create<OrganizationState>()(
  persist(
    (set, get) => ({
      organizations: [],
      selectedOrg: null,
      isLoading: true,

      setOrganizations: (orgs) => {
        const currentSelectedId = get().selectedOrg?._id;
        // Mantener la org seleccionada si sigue existiendo, o seleccionar la primera
        const stillExists = orgs.find((o) => o._id === currentSelectedId);
        set({
          organizations: orgs,
          selectedOrg: stillExists || orgs[0] || null,
        });
      },

      setSelectedOrg: (org) => set({ selectedOrg: org }),

      setLoading: (loading) => set({ isLoading: loading }),

      hasOrgPermission: (permission) => {
        const { selectedOrg } = get();
        if (!selectedOrg?.permissions) return false;
        if (selectedOrg.permissions.includes('*')) return true;
        return selectedOrg.permissions.includes(permission);
      },

      reset: () =>
        set({
          organizations: [],
          selectedOrg: null,
          isLoading: true,
        }),
    }),
    {
      name: 'vida-organization',
      partialize: (state) => ({
        selectedOrg: state.selectedOrg,
      }),
    }
  )
);
